import { searchAi, feedback, IFeedbackRequest } from "../../contract";
import { config } from "../../config";

export const fetchSearchAi = (q: string) => searchAi(config.apiBasePath, { q });

export const postSearchAiFeedback = (input: IFeedbackRequest) =>
  feedback(config.apiBasePath, input);
